import React, { useState, useRef, useEffect, useContext } from "react";
import { FaShoppingCart, FaHeart, FaStar, FaSpinner, FaCoins, FaMinus, FaPlus } from "react-icons/fa";
import { Link, useParams } from "react-router";
import MainHeader from "../../Components/Header/MainHeader";
import ProductQuestionAnswers from "../../Components/Redemption/ProductQuestionAnswers";
import ProductReviewsRatings from "../../Components/Redemption/ProductReviewsRatings";
import Specifications from "../../Components/Redemption/Specifications";
import { BASE_URL_API } from "../../References/URLs";
import AuthContext from "../../Store/AuthContext";
import styles from "./ProductViewClient.module.css";

const ProductViewClient = () => {
    const authCtx = useContext(AuthContext)
    const loginData = JSON.parse(authCtx.loginData)
    const isLoggedIn = authCtx?.isLoggedIn
    const [isUpdating, setIsUpdating] = useState(false)
    const [isPointsBased, setIsPointsBased] = useState(window.location.search.substring(1).split("=")[1])
    const [showSimilarProducts, setShowSimilarProducts] = useState(true);
    const rightColumnRef = useRef(null)
    const { productIdentifier } = useParams()
    const [cartItems, setCartItems] = useState([])
    const [catalogueIdentifier, setCatalogueIdentifier] = useState('')


    const [product, setProduct] = useState({
        title: "Flipkart Perfect Homes Carol Engineered Wood Queen Bed",
        price: 11999,
        discountPrice: 7999,
        discount: 33,
        ratings: 4.3,
        reviews: 584,
        highlights: [
            "Engineered Wood Queen Bed",
            "Ideal for modern bedrooms",
            "1 Year Manufacturer Warranty",
        ],
        images: [
            "https://rukminim1.flixcart.com/image/416/416/bed/q/k/s/engineered-wood-queen-perfect-homes-original-imafzu52py2b4ev9.jpeg",
            "https://rukminim1.flixcart.com/image/416/416/bed/q/k/s/engineered-wood-queen-perfect-homes-original-imafzu52qspvbxzd.jpeg",
        ],
        offers: [
            "10% off on Axis Bank Credit Card",
            "5% Cashback on Flipkart Axis Bank Card",
        ],
    })

    // Scroll event to detect the end of the right column
    const handleScroll = () => {
        const element = rightColumnRef.current;
        if (element) {
            const isScrolledToBottom =
                element.scrollTop + element.clientHeight >= element.scrollHeight;
            setShowSimilarProducts(isScrolledToBottom);
        }
    };

    const getIndiProductData = async () => {
        const getIndiProductDataResponse = await fetch(BASE_URL_API + "getIndiProductDataClient",
            {
                method: "POST",
                body: JSON.stringify({
                    productIdentifier: productIdentifier
                })
            });

        if (!getIndiProductDataResponse.ok) {
            console.log('Something went wrong : Server Error')
        } else {
            const getIndiProductDataRespo = await getIndiProductDataResponse.json()
            if (getIndiProductDataRespo.status === "success") {
                setProduct(getIndiProductDataRespo?.response)
                setIsPointsBased(getIndiProductDataRespo?.isPointsBased)
                setCatalogueIdentifier(getIndiProductDataRespo?.catalogueIdentifier)
            } else {
                if (getIndiProductDataRespo?.message === "token Expired, please login again!") {
                    authCtx.logout()
                }
            }
            console.log(getIndiProductDataRespo)
        }
    }

    useEffect(() => {
        getIndiProductData()
    }, [productIdentifier])

    function normalizeImages(images) {
        // If it's already an array, return it
        if (Array.isArray(images)) return images;

        // If it's a string, try to parse it as JSON
        try {
            const parsed = JSON.parse(images);
            return Array.isArray(parsed) ? parsed : [];
        } catch (error) {
            console.error("Failed to parse images:", error);
            return [];
        }
    }

    const getCartItems = async () => {
        const response = await fetch(BASE_URL_API + "getCartItems", {
            method: "POST",
            body: JSON.stringify({
                token: authCtx.token,
                userIdentifier: loginData?.userIdentifier,
            }),
        });

        if (!response.ok) {
            console.log("Server Error");
        } else {
            const data = await response.json();
            if (data.status === "success") {
                setCartItems(data.response);
            } else {
                if (data.message === "token Expired, please login again!") {
                    authCtx.logout();
                } else {
                    setCartItems([]);
                }
            }
        }
    };

    const [cartItem, setCartItem] = useState(null)
    // Check if the product is already in the cart

    useEffect(() => {
        const cartItem = cartItems.find((item) => item.productIdentifier === product.productIdentifier);
        setCartItem(cartItem)
    }, [cartItems, product])

    const updateCart = async (direction) => {
        setIsUpdating(true);
        const updateCartResponse = await fetch(BASE_URL_API + "updateCart",
            {
                method: "POST",
                body: JSON.stringify({
                    token: authCtx.token,
                    cartItemIdentifier: cartItem.cartItemIdentifier,
                    direction: direction
                }),
            });

        if (!updateCartResponse.ok) {
            console.log("Something went wrong: Server Error");
        } else {
            const updateCartRespo = await updateCartResponse.json();
            if (updateCartRespo.status === "success") {
                getCartItems(); // Refresh cart items
            } else {
                if (updateCartRespo.message === 'token Expired, please login again!') {
                    authCtx.logout()
                } else {
                    console.log(updateCartRespo.message);
                }
            }
        }
        setIsUpdating(false);
    };

    const addToCart = async () => {
        setIsUpdating(true)
        console.log(product)
        const addToCartResponse = await fetch(BASE_URL_API + "addToCart",
            {
                method: "POST",
                body: JSON.stringify({
                    token: authCtx.token,
                    userIdentifier: loginData?.userIdentifier,
                    item: product,
                    isPointsBased: isPointsBased
                })
            });

        if (!addToCartResponse.ok) {
            console.log("Something went wrong : Server Error")
        } else {
            const addToCartRespo = await addToCartResponse.json()
            if (addToCartRespo.status === "success") {
                getCartItems()
            } else {
                if (addToCartRespo.message === "token Expired, please login again!") {
                    authCtx.logout()
                }
            }
        }
        setIsUpdating(false)
    }


    const handleIncrease = () => {
        if (cartItem) {
            updateCart('increase');
        }
    };

    const handleDecrease = () => {
        updateCart('decrease')
    };

    useEffect(() => {
        getCartItems()
    }, [productIdentifier])



    return (
        <div>
            <MainHeader cartItems={cartItems} />
            <div className={styles.container}>
                {/* Left Column */}
                <div className={styles.leftColumn}>
                    <img
                        src={product?.productThumbnail}
                        className={styles.productImage}
                    />
                </div>

                {/* Right Column */}
                <div
                    className={styles.rightColumn}
                    ref={rightColumnRef}
                    onScroll={handleScroll}
                >
                    <div className={styles.pointsOnSale}>
                        Earn {product?.pointsOnSale} points on buying each of this.
                    </div>
                    <div className={styles.productTitle}>{product.productTitle}</div>
                    <div>
                        <div>Brand Name  : {product?.brandName}</div>
                        <div className={styles.categorySubcategoryWrapper}>
                            <div className={styles.category}>{product?.category}</div>
                            <div className={styles.subCategory}>{product?.subCategory}</div>
                        </div>
                    </div>
                    <div className={styles.ratings}>
                        <span className={styles.ratingValue}>
                            {product.ratings} <FaStar />
                        </span>
                        <span className={styles.reviews}>
                            ({product.reviews} Ratings & Reviews)
                        </span>
                    </div>
                    {/* <div className={styles.priceSection}>
                        <span className={styles.discountPrice}>
                            ₹{product.pointsRequired}
                        </span>
                        <span className={styles.originalPrice}>₹{product?.pointsRequired}</span>
                        <span className={styles.discount}>({product?.discount}% off)</span>
                    </div> */}
                    <div
                        dangerouslySetInnerHTML={{ __html: product?.productDescription }}
                    >
                    </div>
                    <div className={styles.offers}>
                        <h3>Available Offers</h3>
                        <ul>
                            {product?.offers?.map((offer, index) => (
                                <li key={index}>{offer}</li>
                            ))}
                        </ul>
                    </div>
                    <div>
                        {isPointsBased === "1" ?
                            <div className={styles.pointsRequired}><FaCoins />{product?.pointsRequired}</div>
                            :
                            <div>₹{product?.mrp}</div>
                        }
                    </div>

                    <div className={styles.addToCartWrapper}>
                        {cartItem ? (
                            <div className={styles.inCartAction}>
                                <div className={styles.quantityControls}>
                                    {isUpdating === true ?
                                        <button
                                            className={styles.decreaseButton}
                                            disabled={isUpdating}
                                        >
                                            <FaSpinner size={18} className={styles.spinner} />
                                        </button>
                                        :
                                        <button
                                            className={styles.decreaseButton}
                                            onClick={handleDecrease}
                                            disabled={isUpdating}
                                        >
                                            <FaMinus />
                                        </button>
                                    }
                                    <span className={styles.quantity}>{cartItem.quantity}</span>
                                    {isUpdating === true ?
                                        <button
                                            className={styles.increaseButton}
                                            disabled={isUpdating}
                                        >
                                            <FaSpinner size={18} className={styles.spinner} />
                                        </button>
                                        :
                                        <button
                                            className={styles.increaseButton}
                                            onClick={handleIncrease}
                                            disabled={isUpdating}
                                        >
                                            <FaPlus />
                                        </button>
                                    }
                                </div>
                                <Link to={`/shop/cart`} className={styles.goToCartBtn}>
                                    Go To Cart
                                </Link>
                            </div>
                        ) : authCtx.isLoggedIn ? (
                            <button
                                className={styles.addToCart}
                                onClick={() => addToCart()}
                            >
                                Add to Cart
                            </button>
                        ) : (
                            <Link to={`/login?landingPage=shop/product/${productIdentifier}`} className={styles.addToCart} >Add To Cart</Link>
                        )}
                    </div>
                    <div className={styles.highlights}>
                        <h3>Highlights</h3>
                        <ul>
                            {product?.highlights?.map((item, index) => (
                                <li key={index}>{item}</li>
                            ))}
                        </ul>
                    </div>
                    {/* <Specifications />
                    <ProductQuestionAnswers />
                    <ProductReviewsRatings /> */}
                </div>
            </div>

            {/* Similar Products Section */}
            {/* {showSimilarProducts && (
                <div className={styles.similarProducts}>
                    <h2>Similar Products</h2>
                    <div className={styles.similarProductsGrid}>
                        {Array.from({ length: 26 }, (_, i) => (
                            <div key={i} className={styles.similarProductCard}>
                                <p>Product {i + 1}</p>
                            </div>
                        ))}
                    </div>
                </div>
            )} */}
        </div>
    );
};

export default ProductViewClient;
